import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDirectoryUpdateProductionCalendarMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useDirectoryUpdateProductionCalendar = () => {
  const [handle, { loading, error: apolloError, data }] =
    useDirectoryUpdateProductionCalendarMutation();

  const error = useError(apolloError);

  const updateProductionCalendar = useCallback(
    async (id: string, versionNumber: number, nonBusinessDays: string[]) => {
      const res = await handle({
        variables: {
          id,
          versionNumber,
          nonBusinessDays,
        },
      });
      if (res.data?.productionCalendar) {
        return res.data.productionCalendar;
      }
      return null;
    },
    [handle]
  );

  return {
    loading,
    error,
    productionCalendar: data?.productionCalendar,
    updateProductionCalendar,
  };
};
